import "../../assets/css/suppliers/suppliers.css"

import client from "../../assets/images/clients.svg"
import industry from "../../assets/images/industries.svg"
import rating from "../../assets/images/rating.svg"
import status from "../../assets/images/status.svg"
import location from "../../assets/images/location.svg"
import certifications from "../../assets/images/certification.svg"
import sortIcon from "../../assets/images/sort.svg"
import printReport from "../../assets/images/printReport.svg"
import starRating from "../../assets/images/starRating.svg"
import viewProfile from "../../assets/images/viewProfile.svg"
import cvpBadge from "../../assets/images/CVPBagdeTable.png"

import close from "../../assets/images/close.svg"

import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import axios from "axios"
import Swal from "sweetalert2"
import { useAuth } from "../../context/auth-user"
import PageSelector from "../pageSelector"

const { 
    REACT_APP_URI_SUPPLIERS_DIRECTORY_AND_REQUESTS: URI_SUPPLIERS_DIRECTORY,
    REACT_APP_URI_SUPPLIERS_FILTERS: URI_SUPPLIERS_FILTERS,
    REACT_APP_REPORT_SUPPLIER_DIRECTORY: URI_REPORT_SUPPLIER_DIRECTORY,
    REACT_APP_URI_UPLOADS: URI_UPLOADS
} = process.env;

const statusFilterArray = ["Authorized", "Rejected", "Active", "Hold payment"]
const itemsPerPage = 20

export default function Suppliers({ darkLightMode }) {
    const { user } = useAuth()
    const userLogged = user?.selectedProfile

    // VARIABLE TO NAVIGATE TO OTHER COMPONENT
    const navigate = useNavigate();

    const locationUrl = useLocation();

    const [currentPage, setCurrentPage] = useState(() => {
        const storedPage = sessionStorage.getItem("currentPageSupplier");
        return storedPage ? parseInt(storedPage, 10) : 1;
    });

    const [searchValue, setSearchValue] = useState(() => {
        const stored = localStorage.getItem("suppDirFilters")

        return JSON.parse(stored)?.searchValue ?? ""
    })
    const [applySearchFilter, setApplySearchFilter] = useState(searchValue)

    const [industrySearch, setIndustrySearch] = useState("")
    const [locationSearch, setLocationSearch] = useState("")

    const [openFilter, setOpenFilter] = useState(null)

    // VARAIBLE TO CONTROL THE SORT ORDER
    const [order, setOrder] = useState("ASC")
    const [orderBy, setOrderBy] = useState("companyName")

    // VARIABLES TO CONTROL SORT MENU SHOW AND HIDE
    const [showSortMenu, setShowSortMenu] = useState(false)

    // VARIABLE TO MANAGE FILTER AND MOBILE SORT MENU
    const sortMenuRef = useRef(null)
    const filterRef = useRef(null)

    const { clientID: locationClientID, industryName: locationIndustryName } = locationUrl.state || {}
    
    // VARIABLES TO CONTROL FILTER DATA
    const [clientFilter, setClientFilter] = useState(() => {
        if (locationClientID) return [locationClientID]
        
        const stored = localStorage.getItem("suppDirFilters") ?? JSON.stringify({})

        return JSON.parse(stored)?.client ?? []
    })

    if (locationUrl.state?.clientID) {
        const rest = { ...locationUrl.state }

        delete rest.clientID

        window.history.replaceState(rest, document.title, locationUrl.pathname + locationUrl.search);
    }
    
    const [entityFilter, setEntityFilter] = useState(() => {
        const stored = localStorage.getItem("suppDirFilters") ?? JSON.stringify({})

        return JSON.parse(stored)?.entity ?? []
    })

    if (locationUrl.state?.industryName) {
        const rest = { ...locationUrl.state }

        delete rest.industryName

        window.history.replaceState(rest, document.title, locationUrl.pathname + locationUrl.search);
    }

    const [industryFilter, setIndustryFilter] = useState(() => {
        if (locationIndustryName) return [locationIndustryName]

        const stored = localStorage.getItem("suppDirFilters") ?? JSON.stringify({})

        return JSON.parse(stored)?.industry ?? []
    })
    const [ratingFilter, setRatingFilter] = useState(() => {
        const stored = localStorage.getItem("suppDirFilters") ?? JSON.stringify({})

        return JSON.parse(stored)?.rating ?? 0
    })
    const [statusFilter, setStatusFilter] = useState(() => {
        const stored = localStorage.getItem("suppDirFilters") ?? JSON.stringify({})

        return JSON.parse(stored)?.status ?? []
    })
    const [locationFilter, setLocationFilter] = useState(() => {
        const stored = localStorage.getItem("suppDirFilters") ?? JSON.stringify({})

        return JSON.parse(stored)?.location ?? []
    })
    const [certificationsFilter, setCertificationsFilter] = useState(() => {
        const stored = localStorage.getItem("suppDirFilters") ?? JSON.stringify({})

        return JSON.parse(stored)?.certification ?? []
    })
    const [cvpFilter, setCvpFilter] = useState(() => {
        const stored = localStorage.getItem("suppDirFilters") ?? JSON.stringify({})

        return JSON.parse(stored)?.cvp ?? false
    })

    // VARIABLES TO KNOW IF THE FILTER IS ON
    const [clientIsFiltered, setClientIsFiltered] = useState(() => {
        if (locationClientID) return true
        
        const stored = localStorage.getItem("suppDirFilters") ?? JSON.stringify({})

        return JSON.parse(stored)?.client ? true : false
    })
    const [entityIsFiltered, setEntityIsFiltered] = useState(() => {
        const stored = localStorage.getItem("suppDirFilters") ?? JSON.stringify({})

        return JSON.parse(stored)?.entity ? true : false
    })
    const [industryIsFiltered, setIndustryIsFiltered] = useState(() => {
        if (locationIndustryName) return true

        const stored = localStorage.getItem("suppDirFilters") ?? JSON.stringify({})

        return JSON.parse(stored)?.industry ? true : false
    })
    const [statusIsFiltered, setStatusIsFiltered] = useState(() => {
        const stored = localStorage.getItem("suppDirFilters") ?? JSON.stringify({})

        return JSON.parse(stored)?.status ? true : false
    })
    const [locationIsFiltered, setLocationIsFiltered] = useState(() => {
        const stored = localStorage.getItem("suppDirFilters") ?? JSON.stringify({})

        return JSON.parse(stored)?.location ? true : false
    })
    const [certificationsIsFiltered, setCertificationsIsFiltered] = useState(() => {
        const stored = localStorage.getItem("suppDirFilters") ?? JSON.stringify({})

        return JSON.parse(stored)?.certification ? true : false
    })

    // VARIABLES TO FILTER DATA
    const [clientFilterApplied, setClientFilterApplied] = useState(() => {
        if (clientIsFiltered) return clientFilter

        return []
    })

    const [entityFilterApplied, setEntityFilterApplied] = useState(() => {
        if (entityIsFiltered) return entityFilter

        return []
    })
    const [industryFilterApplied, setIndustryFilterApplied] = useState(() => {
        if (industryIsFiltered) return industryFilter

        return []
    })
    const [statusFilterApplied, setStatusFilterApplied] = useState(() => {
        if (statusIsFiltered) return statusFilter

        return []
    })
    const [locationFilterApplied, setLocationFilterApplied] = useState(() => {
        if (locationIsFiltered) return locationFilter

        return []
    })
    const [certificationsFilterApplied, setCertificationsFilterApplied] = useState(() => {
        if (certificationsIsFiltered) return certificationsFilter

        return []
    })

    //VARIABLE TO SHOW RESET ALL FILTERS
    const [resetAll, setResetAll] = useState(false)

    const mainStyle = {
        background: darkLightMode ? "#131E29" : "white",
        color: darkLightMode ? "white" : "inherit"
    }

    const [supplierDirectoryData, setSupplierDirectoryData] = useState({})
    // Cache local para data de tabla: { cacheKey: data }
    const [cache, setCache] = useState({})

    const [filtersData, setFiltersData] = useState({})

    const getFilters = useCallback(async ({ signal }) => {
        try {
            const query = new URLSearchParams();
            query.append("rol", userLogged?.rol);
            query.append("clientID", userLogged?.dataID);

            const { data } = await axios.get(`${URI_SUPPLIERS_FILTERS}?${query.toString()}`, { signal });

            setFiltersData(data)
        } catch (error) {
            if (error.name === "AbortError") return
            
            const errorMessage = error.response?.data?.message || "An error occurred while fetching filters.";
            console.error("Error fetching filters: ", errorMessage);
        }
    }, [userLogged])

    const cacheKey = useMemo(() => {
        return [
            applySearchFilter,
            orderBy + ':' + order,
            'page:' + currentPage,
            'limit:' + itemsPerPage,
            'client:' + clientFilterApplied.join(','),
            'entity:' + entityFilterApplied.join(','),
            'industry:' + industryFilterApplied.join(','),
            'rating:' + ratingFilter,
            'status:' + statusFilterApplied.join(','),
            'location:' + locationFilterApplied.join(','),
            'cert:' + certificationsFilterApplied.join(','),
            'cvp:' + cvpFilter
        ].join('__');
    }, [applySearchFilter, order, orderBy, currentPage, clientFilterApplied, entityFilterApplied, industryFilterApplied, ratingFilter, statusFilterApplied, locationFilterApplied, certificationsFilterApplied, cvpFilter])

    const getSupplierDirectory = useCallback(async ({ 
        userLogged, 
        signal, 
        search = "", 
        order = "ASC", 
        orderBy = "companyName", 
        page = 1, 
        limit = itemsPerPage,
        clientFilterApplied = [],
        entityFilterApplied = [],
        industryFilterApplied = [],
        ratingFilterApplied = 0,
        statusFilterApplied = [],
        locationFilterApplied = [],
        certificationsFilterApplied = [],
        cvpFilterApplied = false
    }) => {
        try {
            const query = new URLSearchParams();
            query.append("rol", userLogged.rol);
            query.append("clientID", userLogged.dataID);
            query.append("search", search)
            query.append("order", order)
            query.append("orderBy", orderBy)
            query.append("page", page)
            query.append("limit", limit)

            if (clientFilterApplied.length > 0) clientFilterApplied.forEach(val => query.append("clientFilterApplied[]", val));
            if (entityFilterApplied.length > 0) entityFilterApplied.forEach(val => query.append("entityFilterApplied[]", val));
            if (industryFilterApplied.length > 0) industryFilterApplied.forEach(val => query.append("industryFilterApplied[]", val));
            if (ratingFilterApplied > 0) query.append("ratingFilterApplied", ratingFilterApplied);
            if (statusFilterApplied.length > 0) statusFilterApplied.forEach(val => query.append("statusFilterApplied[]", val));
            if (locationFilterApplied.length > 0) locationFilterApplied.forEach(val => query.append("locationFilterApplied[]", val));
            if (certificationsFilterApplied.length > 0) certificationsFilterApplied.forEach(val => query.append("certificationsFilterApplied[]", val));
            if (cvpFilterApplied) query.append("cvpFilterApplied", cvpFilterApplied);

            Swal.fire({
                footer: 'Loading, please wait',
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => {
                    Swal.showLoading()
                },
            })

            const { data } = await axios.get(`${URI_SUPPLIERS_DIRECTORY}?${query.toString()}`, { signal });

            // Guardar respuesta completa en cache local
            setCache(prev => ({ ...prev, [cacheKey]: data }));
            setSupplierDirectoryData(data);

            Swal.close()
        } catch (error) {
            if (error.name === "AbortError") return;

            const errorMessage = error.response?.data?.message || "An error occurred while fetching supplier directory.";
            
            console.error("Error fetching supplier directory: ", errorMessage);

            Swal.fire({
                icon: 'error',
                text: 'Failed to get suppliers directory',
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
            })
        }
    }, [cacheKey]);
    
    useEffect(() => {
        const controller = new AbortController();

        const { signal } = controller;

        if (!userLogged) return

        getFilters({ signal })

        return () => controller.abort()
    }, [userLogged, getFilters])

    useEffect(() => {
        const controller = new AbortController();

        const { signal } = controller;

        if (!userLogged) return

        if (cache[cacheKey]) {
            setSupplierDirectoryData(cache[cacheKey]);

            return () => controller.abort()
        } else {
            const handler = setTimeout(() => {
                getSupplierDirectory({ 
                    userLogged, 
                    signal, 
                    search: applySearchFilter, 
                    orderBy, 
                    order, 
                    page: currentPage, 
                    limit: itemsPerPage,
                    clientFilterApplied,
                    entityFilterApplied,
                    industryFilterApplied,
                    ratingFilterApplied: ratingFilter,
                    statusFilterApplied,
                    locationFilterApplied,
                    certificationsFilterApplied,
                    cvpFilterApplied: cvpFilter
                })
            }, 300)

            return () => {
                clearTimeout(handler)
                controller.abort()
            }
        }
    }, [userLogged, getSupplierDirectory, applySearchFilter, order, orderBy, currentPage, clientFilterApplied, entityFilterApplied, industryFilterApplied, ratingFilter, statusFilterApplied, locationFilterApplied, certificationsFilterApplied, cvpFilter, cache, cacheKey])

    
    // useEffect to add body listener
    useEffect(() => {
        window.onbeforeunload = clearSessionStorage;

        document.body.addEventListener("mousedown", closeMenusFilters)

        return function cleanUp() {
            window.onbeforeunload = null; // Cleanup event listener
            document.body.removeEventListener("mousedown", closeMenusFilters)
        }
    }, [])

    // COMPARATION TO SHOW THE RESET ALL BUTTON
    useEffect(() => {
        if (clientIsFiltered || entityIsFiltered || industryIsFiltered || ratingFilter || statusIsFiltered || locationIsFiltered || certificationsIsFiltered || cvpFilter) {
            setResetAll(true)
        } else {
            setResetAll(false)
        }
    }, [clientIsFiltered, entityIsFiltered, industryIsFiltered, ratingFilter, statusIsFiltered, locationIsFiltered, certificationsIsFiltered, cvpFilter])

    // CLEAR SESSION STORAGE ON PAGE REFRESH
    const clearSessionStorage = () => {
        sessionStorage.removeItem('currentPageSupplier');
    };

    // FUNCTION TO CLOSE MENU FILTERS
    const closeMenusFilters = (e) => {
        if (!filterRef?.current?.contains(e.target)) {
            setOpenFilter(null)
        }

        if (!sortMenuRef?.current?.contains(e.target)) {
            setShowSortMenu(false)
        }
    }

    const handleOpenFilter = (e, filterName) => {
        filterRef.current = e.target

        setOpenFilter(prev => {
            if (prev === filterName) return null

            return filterName
        })
    }

    // FUNCTION TO SORT TABLE COLUMN
    const sortTable = (order, sortBy) => {
        setOrder(order)
        setOrderBy(sortBy)   
    }

    // FUNCTIONS TO ADD FILTERS
    const toggleFilterValue = (setFilter) => (target) => {
        setFilter(prev => {
            const existValue = prev.some(valueToFind => valueToFind === target.value);

            if (existValue) {
                return prev.filter(valueToFind => valueToFind !== target.value);
            }

            return [...prev, target.value];
        });
    };

    const handleRating = (value) => {
        const prevFilters = JSON.parse(localStorage.getItem("suppDirFilters") ?? "{}")
        let saveFilters = {}

        saveFilters = {
            ...prevFilters,
            rating: value
        }

        setRatingFilter(value)

        localStorage.setItem("suppDirFilters", JSON.stringify(saveFilters))
    }

    const handleCvp = (value) => {
        const prevFilters = JSON.parse(localStorage.getItem("suppDirFilters") ?? "{}")
        let saveFilters = {}

        saveFilters = {
            ...prevFilters,
            cvp: value
        }

        setCvpFilter(value)

        localStorage.setItem("suppDirFilters", JSON.stringify(saveFilters))
    }

    // FUNTION TO GET THE TABLE REPORT
    const getTableReport = () => {
        Swal.fire({
            footer: 'Loading, please wait',
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
                Swal.showLoading()
            },
        })

        axios.post(URI_REPORT_SUPPLIER_DIRECTORY, {
            userLogged: userLogged,
            filters: {
                searchFilter: applySearchFilter,
                clientFilter: clientFilterApplied,
                entityFilter: entityFilterApplied,
                industryFilter: industryFilterApplied,
                ratingFilter: ratingFilter,
                statusFilter: statusFilterApplied,
                locationFilter: locationFilterApplied,
                certificationsFilter: certificationsFilterApplied,
                cvpFilter: cvpFilter
            }
        }).then(response => {
            Swal.fire({
                icon: 'success',
                text: `${response.data.message}`,
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
            })

            window.open(URI_UPLOADS + response.data.path, "_blank")
        }).catch(err => {
            Swal.fire({
                icon: 'error',
                text: 'Failed to generate the report',
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
            })
        })
    }

    // FUNCTION TO FILTER THE SUPPLIER DIRECTORY BY INPUT SEARCH
    const searchFilter = (value) => {
        setSearchValue(value)

        // SAVE VALUE IN LOCAL STORAGE
        const searchValueToLocal = {
            searchValue: value
        }

        localStorage.setItem("suppDirFilters", JSON.stringify(searchValueToLocal))

        setCurrentPage(1)
    }

    const applyFilter = (filterToApply) => {
        setSearchValue("")
        setApplySearchFilter("")
        const prevFilters = JSON.parse(localStorage.getItem("suppDirFilters") ?? "{}")
        if (prevFilters.hasOwnProperty("searchValue")) {
            delete prevFilters.searchValue;
        }
        let saveFilters = {}
        
        switch (filterToApply) {
            case "client": {
                if (clientFilter.length > 0) {
                    setClientIsFiltered(true)
                    setClientFilterApplied(clientFilter)
                    setEntityFilter([])
                    setEntityIsFiltered(false)
                    setEntityFilterApplied([])

                    saveFilters = {
                        ...prevFilters,
                        client: clientFilter
                    }

                }

                break;
            }

            case "entity": {
                if (entityFilter.length > 0) {
                    setEntityIsFiltered(true)
                    setEntityFilterApplied(entityFilter)

                    saveFilters = {
                        ...prevFilters,
                        entity: entityFilter
                    }
                }

                break;
            }

            case "industry": {
                if (industryFilter.length > 0) {
                    setIndustryIsFiltered(true)
                    setIndustryFilterApplied(industryFilter)
                    saveFilters = {
                        ...prevFilters,
                        industry: industryFilter
                    }
                }

                break;
            }

            case "status": {
                if (statusFilter.length > 0) {
                    setStatusIsFiltered(true)
                    setStatusFilterApplied(statusFilter)
                    saveFilters = {
                        ...prevFilters,
                        status: statusFilter
                    }
                }

                break;
            }

            case "location": {
                if (locationFilter.length > 0) {
                    setLocationIsFiltered(true)
                    setLocationFilterApplied(locationFilter)
                    saveFilters = {
                        ...prevFilters,
                        location: locationFilter
                    }
                }

                break;
            }

            case "certifications": {
                if (certificationsFilter.length > 0) {
                    setCertificationsIsFiltered(true)
                    setCertificationsFilterApplied(certificationsFilter)
                    saveFilters = {
                        ...prevFilters,
                        certification: certificationsFilter
                    }
                }

                break;
            }

            default:
                break;
        }

        localStorage.setItem("suppDirFilters", JSON.stringify(saveFilters))
    }

    // FUNCTION TO CLEAR THE SUPPLIER DIRECTORY BY FILTER BUTTONS AND RESET ALL ON DEFAULT CASE
    const clearFilter = (filter) => {
        let savedFilters = JSON.parse(localStorage.getItem("suppDirFilters") ?? "{}")
        
        switch (filter) {
            case "client":
                setClientFilter([])
                setClientIsFiltered(false)
                if (clientFilterApplied.length > 0) setClientFilterApplied([]) 

                setEntityFilter([])
                setEntityIsFiltered(false)
                if (entityFilterApplied.length > 0) setEntityFilterApplied([])

                if (savedFilters.hasOwnProperty("client")) {
                    delete savedFilters.client;
                }

                if (savedFilters.hasOwnProperty("entity")) {
                    delete savedFilters.entity;
                }
                break;

            case "entity":
                setEntityFilter([])
                setEntityIsFiltered(false)
                if(entityFilterApplied.length > 0) setEntityFilterApplied([])
                if (savedFilters.hasOwnProperty("entity")) {
                    delete savedFilters.entity;
                }
                break;

            case "industry":
                setIndustryFilter([])
                setIndustryIsFiltered(false)
                if (industryFilterApplied.length > 0) setIndustryFilterApplied([])
                if (savedFilters.hasOwnProperty("industry")) {
                    delete savedFilters.industry;
                }

                break;

            case "rating":
                setRatingFilter(0)
                if (savedFilters.hasOwnProperty("rating")) {
                    delete savedFilters.rating;
                }
                break;

            case "status":
                setStatusFilter([])
                setStatusIsFiltered(false)
                if (statusFilterApplied.length > 0) setStatusFilterApplied([])
                if (savedFilters.hasOwnProperty("status")) {
                    delete savedFilters.status;
                }
                break;

            case "location":
                setLocationFilter([])
                setLocationIsFiltered(false)
                if (locationFilterApplied.length > 0) setLocationFilterApplied([])
                if (savedFilters.hasOwnProperty("location")) {
                    delete savedFilters.location;
                }
                break;

            case "certifications":
                setCertificationsFilter([])
                setCertificationsIsFiltered(false)
                if (certificationsFilterApplied.length > 0) setCertificationsFilterApplied([])
                if (savedFilters.hasOwnProperty("certification")) {
                    delete savedFilters.certification;
                }
                break;

            case "all": {
                setClientFilter([])
                setClientIsFiltered(false)
                setClientFilterApplied([])

                setEntityFilter([])
                setEntityIsFiltered(false)
                setEntityFilterApplied([])

                setIndustryFilter([])
                setIndustryIsFiltered(false)
                setIndustryFilterApplied([])

                setRatingFilter(0)

                setStatusFilter([])
                setStatusIsFiltered(false)
                setStatusFilterApplied([])

                setLocationFilter([])
                setLocationIsFiltered(false)
                setLocationFilterApplied([])

                setCertificationsFilter([])
                setCertificationsIsFiltered(false)
                setCertificationsFilterApplied([])

                setCvpFilter(false)

                localStorage.removeItem("suppDirFilters")
                
                break;
            }

            default:
                break;
        }


        if (filter !== "all") localStorage.setItem("suppDirFilters", JSON.stringify(savedFilters))
    }

    // FUNCTION TO CREATE THE ENTITY LIST TO SHOW ON FILTER BUTTON
    const createEntityFilter = () => {
        let filterEntity

        switch (userLogged?.rol) {
            case "Master":
            case "Super admin":
                filterEntity = new Set(filtersData?.clientsFilter?.filter(client => {
                    return clientFilter.includes(client._id)
                }).flatMap(client => client.entities.map(entity => entity)))

                return Array.from(filterEntity)

            case "Admin client":
            case "Admin Compliance manager":
                filterEntity = new Set(filtersData?.clientsFilter?.filter(client => {
                    return userLogged.dataID === client._id
                }).flatMap(client => client.entities.map(entity => entity)))

                return Array.from(filterEntity)

            default:
                break;
        }
    }

    const totalPagesFinal = Math.ceil((supplierDirectoryData?.total ?? 1) / itemsPerPage)

    function paginate(pageNumber) {
        if (pageNumber < 1 || pageNumber > totalPagesFinal) return;
        
        sessionStorage.setItem("currentPageSupplier", pageNumber);
        setCurrentPage(pageNumber);
    }

    const tableCount = useMemo(() => itemsPerPage * currentPage > supplierDirectoryData?.total ? supplierDirectoryData?.total : itemsPerPage * currentPage, [currentPage, supplierDirectoryData?.total]);
    
    
    const handleSetSearchFilterValue = (e) => {
        e.preventDefault();
        
        if (clientIsFiltered || 
            entityIsFiltered || 
            industryIsFiltered || 
            ratingFilter || 
            statusIsFiltered || 
            locationIsFiltered || 
            certificationsIsFiltered || 
            cvpFilter
        ) {
            clearFilter("all")
        }
        
        setApplySearchFilter(searchValue);
    }
    
    return (
        <section className={`supplier ${darkLightMode ? "darkMode" : null}`}>
            <div className="titleAndSearch">
                <h3 className="title">Supplier Directory</h3>
                <div className="searchAndSort">
                    <form onSubmit={handleSetSearchFilterValue}>
                        <div className={`searchContainer ${darkLightMode ? "darkMode" : null}`}>
                            <input id="generalSearch" type="text" placeholder="Search by name..."
                                value={searchValue} onChange={(e) => searchFilter(e.target.value)} />

                            <button className='applySearchButton' type="submit"></button>
                        </div>
                    </form>
                    <button ref={sortMenuRef} className="d-lg-none sortMobile" onClick={() => setShowSortMenu(true)}>Sort</button>
                    <div className={`d-lg-none sortDataContainer ${showSortMenu ? "show" : ""}`}>
                        <h5 className="title">Sort</h5>
                        <span onClick={() => { sortTable("ASC", "companyName") }}>Name (ascending)</span>
                        <span onClick={() => { sortTable("DSC", "companyName") }}>Name (descending)</span>
                        <span onClick={() => { sortTable("ASC", "industries") }}>Industry (ascending)</span>
                        <span onClick={() => { sortTable("DSC", "industries") }}>Industry (descending)</span>
                        <span onClick={() => { sortTable("ASC", "rating") }}>Rating (ascending)</span>
                        <span onClick={() => { sortTable("DSC", "rating") }}>Rating (descending)</span>
                        <span onClick={() => { sortTable("ASC", "location") }}>Location (ascending)</span>
                        <span onClick={() => { sortTable("DSC", "location") }}>Location (descending)</span>
                        <span onClick={() => { sortTable("ASC", "comliant") }}>Documentation (ascending)</span>
                        <span onClick={() => { sortTable("DSC", "comliant") }}>Documentation (descending)</span>
                    </div>
                </div>
            </div>
            <div className="filters">
                {userLogged && (userLogged?.rol === "Master" || userLogged?.rol === "Super admin") &&
                    <div className={`filter ${openFilter === "client" ? "show" : null} ${darkLightMode ? "darkMode" : null} ${clientIsFiltered ? "active" : undefined}`} onClick={(e) => handleOpenFilter(e, "client")}>
                        <img src={client} alt="Prodensa Supplier" />
                        <span>Client</span>
                        <div className={`filterOptions ${openFilter === "client" ? "show" : null}`} onClick={(e) => !e.target.matches("button") && e.stopPropagation()}>
                            <img src={close} alt="Prodensa Supplier" onClick={() => setOpenFilter(null)} className="closeImg d-lg-none" />
                            <span className="title">
                                <img className="d-lg-none imgMenu" src={client} alt="Prodensa Supplier" />
                                Client
                            </span>
                            <div className="optionsScroll">
                                {filtersData?.clientsFilter?.map((client, index) => {
                                    if (client.generalInformation.clientName === "Admin Prodensa") return null
                                    
                                    return (
                                        <div key={"Client" + index} className="option">
                                            <input checked={clientFilter.includes(client?._id?.toString())} className="clientCheck" value={client._id} type="checkbox" id={`client${index}`} onChange={(e) => toggleFilterValue(setClientFilter)(e.target)} />
                                            <label htmlFor={`client${index}`}>{client.generalInformation.clientName}</label>
                                        </div>
                                    )
                                })}
                            </div>
                            <div className="actions">
                                <button onClick={() => clearFilter("client")}>Clear</button>
                                <button onClick={() => applyFilter("client")}>Apply</button>
                            </div>
                        </div>
                    </div>}
                {(clientIsFiltered || (userLogged && (userLogged?.rol === "Admin client" || userLogged?.rol === "Admin Compliance manager"))) &&
                    <div className={`filter ${openFilter === "entity" ? "show" : null} ${darkLightMode ? "darkMode" : null} ${entityIsFiltered ? "active" : undefined}`} onClick={(e) => handleOpenFilter(e, "entity")}>
                        <img src={client} alt="Prodensa Supplier" />
                        <span>Entity</span>
                        <div className={`filterOptions ${openFilter === "entity" ? "show" : null}`} onClick={(e) => !e.target.matches("button") && e.stopPropagation()}>
                            <img src={close} alt="Prodensa Supplier" onClick={() => setOpenFilter(null)} className="closeImg d-lg-none" />
                            <span className="title">
                                <img className="d-lg-none imgMenu" src={client} alt="Prodensa Supplier" />
                                Entity
                            </span>
                            <div className="optionsScroll">
                                {createEntityFilter()?.map((entity, index) => {
                                    return (
                                        <div key={"Entity" + index} className="option">
                                            <input checked={entityFilter.includes(entity?._id?.toString())} className="entityCheck" value={entity._id} type="checkbox" id={`entity${index}`} onChange={(e) => toggleFilterValue(setEntityFilter)(e.target)} />
                                            <label htmlFor={`entity${index}`} >{entity.entityName}</label>
                                        </div>
                                    )
                                })}
                            </div>
                            <div className="actions">
                                <button onClick={() => clearFilter("entity")}>Clear</button>
                                <button onClick={() => applyFilter("entity")}>Apply</button>
                            </div>
                        </div>
                    </div>}
                <div className={`filter ${openFilter === "industry" ? "show" : null} ${darkLightMode ? "darkMode" : null} ${industryIsFiltered ? "active" : undefined}`} onClick={(e) => handleOpenFilter(e, "industry")}>
                    <img src={industry} alt="Prodensa Supplier" />
                    <span>Industry</span>
                    <div className={`searchContainer ${openFilter === "industry" ? "show" : null}`} onClick={(e) => e.stopPropagation()}>
                        <input value={industrySearch} type="text" placeholder="Search industries"
                            onChange={(e) => setIndustrySearch(e.target.value)} />
                    </div>
                    <div className={`filterOptions location ${openFilter === "industry" ? "show" : null}`} onClick={(e) => !e.target.matches("button") && e.stopPropagation()}>
                        <img src={close} alt="Prodensa Supplier" onClick={() => setOpenFilter(null)} className="closeImg d-lg-none" />
                        <span className="title">
                            <img className="d-lg-none imgMenu" src={industry} alt="Prodensa Supplier" />
                            Industry
                        </span>
                        <div className="optionsScroll">
                            {filtersData?.industriesFilter?.filter(ind => !industrySearch || ind.toLocaleLowerCase()?.includes(industrySearch.toLocaleLowerCase())).map((industry, index) => {
                                return (
                                    <div key={"Industry" + index} className="option">
                                        <input checked={industryFilter.includes(industry)} className="industryCheck" value={industry} type="checkbox" id={`industry${index}`} onChange={(e) => toggleFilterValue(setIndustryFilter)(e.target)} />
                                        <label htmlFor={`industry${index}`} >{industry}</label>
                                    </div>
                                )
                            })}
                        </div>
                        <div className="actions">
                            <button onClick={() => clearFilter("industry")}>Clear</button>
                            <button onClick={() => applyFilter("industry")}>Apply</button>
                        </div>
                    </div>
                </div>
                <div className={`filter ${openFilter === "rating" ? "show" : null} ${darkLightMode ? "darkMode" : null} ${ratingFilter ? "active" : undefined}`} onClick={(e) => handleOpenFilter(e, "rating")}>
                    <img src={rating} alt="Prodensa Supplier" />
                    <span>Rating</span>
                    <div className={`filterOptions rating ${openFilter === "rating" ? "show" : null}`} onClick={(e) => !e.target.matches("button") && e.stopPropagation()}>
                        <img src={close} alt="Prodensa Supplier" onClick={() => setOpenFilter(null)} className="closeImg d-lg-none" />
                        <span className="title">Rating</span>
                        <div className="option">
                            <span className="ratingFilter" onClick={() => handleRating(1)}>+ 1.0</span>
                        </div>
                        <div className="option">
                            <span className="ratingFilter" onClick={() => handleRating(2)}>+ 2.0</span>
                        </div>
                        <div className="option">
                            <span className="ratingFilter" onClick={() => handleRating(3)}>+ 3.0</span>
                        </div>
                        <div className="option">
                            <span className="ratingFilter" onClick={() => handleRating(4)}>+ 4.0</span>
                        </div>
                        <div className="actions">
                            <button className="ratingClear" onClick={() => clearFilter("rating")}>Clear</button>
                        </div>
                    </div>
                </div>
                <div className={`filter ${openFilter === "status" ? "show" : null} ${darkLightMode ? "darkMode" : null} ${statusIsFiltered ? "active" : undefined}`} onClick={(e) => handleOpenFilter(e, "status")}>
                    <img src={status} alt="Prodensa Supplier" />
                    <span>Status</span>
                    <div className={`filterOptions ${openFilter === "status" ? "show" : null}`} onClick={(e) => !e.target.matches("button") && e.stopPropagation()}>
                        <img src={close} alt="Prodensa Supplier" onClick={() => setOpenFilter(null)} className="closeImg d-lg-none" />
                        <span className="title">
                            <img className="d-lg-none imgMenu" src={status} alt="Prodensa Supplier" />
                            Status
                        </span>
                        <div className="optionsScroll">
                            {statusFilterArray.map((filter, index) => (
                                <div key={"Status" + index} className="option">
                                    <input checked={statusFilter.includes(filter)} className="statusCheck" value={filter} type="checkbox" id={`status${index}`} onChange={(e) => toggleFilterValue(setStatusFilter)(e.target)} />
                                    <label htmlFor={`status${index}`}>{filter}</label>
                                </div>
                            ))}
                        </div>
                        <div className="actions">
                            <button onClick={() => clearFilter("status")}>Clear</button>
                            <button onClick={() => applyFilter("status")}>Apply</button>
                        </div>
                    </div>
                </div>
                <div className={`filter ${openFilter === "location" ? "show" : null} ${darkLightMode ? "darkMode" : null} location ${locationIsFiltered ? "active" : undefined}`} onClick={(e) => handleOpenFilter(e, "location")}>
                    <img src={location} alt="Prodensa Supplier" />
                    <span>Location</span>
                    <div className={`searchContainer ${openFilter === "location" ? "show" : null}`} onClick={(e) => e.stopPropagation()}>
                        <input value={locationSearch} type="text" placeholder="Search cities"
                            onChange={(e) => setLocationSearch(e.target.value)} />
                    </div>
                    <div className={`filterOptions location ${openFilter === "location" ? "show" : null}`} onClick={(e) => !e.target.matches("button") && e.stopPropagation()}>
                        <img src={close} alt="Prodensa Supplier" onClick={() => setOpenFilter(null)} className="closeImg d-lg-none" />
                        <span className="title">
                            <img className="d-lg-none imgMenu" src={location} alt="Prodensa Supplier" />
                            Location
                        </span>
                        <div className="optionsScroll">
                            {filtersData?.locationFilter?.filter(item => !locationSearch || item.toLocaleLowerCase().includes(locationSearch.toLocaleLowerCase()))
                                .map((filter, index) => (
                                    <div key={"Location" + index} className="option">
                                        <input checked={locationFilter.includes(filter)} className="locationCheck" value={filter} type="checkbox" id={`location${index}`} onChange={(e) => toggleFilterValue(setLocationFilter)(e.target)} />
                                        <label htmlFor={`location${index}`} >{filter}</label>
                                    </div>
                                ))}
                        </div>
                        <div className="actions">
                            <button onClick={() => clearFilter("location")}>Clear</button>
                            <button onClick={() => applyFilter("location")}>Apply</button>
                        </div>
                    </div>
                </div>
                <div className={`filter ${openFilter === "certifications" ? "show" : null} ${darkLightMode ? "darkMode" : null} ${certificationsIsFiltered ? "active" : undefined}`} onClick={(e) => handleOpenFilter(e, "certifications")}>
                    <img src={certifications} alt="Prodensa Supplier" />
                    <span>Certifications</span>
                    <div className={`filterOptions ${openFilter === "certifications" ? "show" : null}`} onClick={(e) => !e.target.matches("button") && e.stopPropagation()}>
                        <img src={close} alt="Prodensa Supplier" onClick={() => setOpenFilter(null)} className="closeImg d-lg-none" />
                        <span className="title">
                            <img className="d-lg-none imgMenu" src={certifications} alt="Prodensa Supplier" />
                            Certifications
                        </span>
                        <div className="optionsScroll">
                            {filtersData?.certificationsFilter?.map((certifications, index) => {
                                return (
                                    <div key={"Certification" + index} className="option">
                                        <input checked={certificationsFilter.includes(certifications)} className="certificationsCheck" value={certifications} type="checkbox" id={`certifications${index}`} onChange={(e) => toggleFilterValue(setCertificationsFilter)(e.target)} />
                                        <label htmlFor={`certifications${index}`} >{certifications}</label>
                                    </div>
                                )
                            })}
                        </div>
                        <div className="actions">
                            <button onClick={() => clearFilter("certifications")}>Clear</button>
                            <button onClick={() => applyFilter("certifications")}>Apply</button>
                        </div>
                    </div>
                </div>

                <div className={`checkboxFilter ${darkLightMode ? "darkMode" : ""}`}>
                    <img src={certifications} alt="Prodensa Supplier" />

                    <label htmlFor="cvpCheckbox">CVP</label>

                    <input type="checkbox" id="cvpCheckbox" checked={cvpFilter} onChange={() => handleCvp(!cvpFilter)} />
                </div>
                <span className={`resetAll ${resetAll ? "show" : ""}`} onClick={() => clearFilter("all")}>Reset All</span>
            </div>
            <span className={`resetAll ${resetAll ? "show" : ""} d-lg-none`} onClick={() => clearFilter("all")}>Reset All</span>

            <table className="tableSuppliers">
                <thead>
                    <tr>
                        <th style={mainStyle}>
                            <span>Name</span>
                            <img className="sort" src={sortIcon} alt="Prodensa supplier" onClick={() => sortTable(order === "ASC" ? "DSC" : "ASC", "companyName")} />
                        </th>
                        <th style={mainStyle}>
                            <span>Industry</span>
                            <img className="sort" src={sortIcon} alt="Prodensa supplier" onClick={() => sortTable(order === "ASC" ? "DSC" : "ASC", "industries")} />
                        </th>
                        <th style={mainStyle}>
                            <span>Rating</span>
                            <img className="sort" src={sortIcon} alt="Prodensa supplier" onClick={() => sortTable(order === "ASC" ? "DSC" : "ASC", "rating")} />
                        </th>
                        <th style={mainStyle}>
                            <span>Location</span>
                            <img className="sort" src={sortIcon} alt="Prodensa supplier" onClick={() => sortTable(order === "ASC" ? "DSC" : "ASC", "location")} />
                        </th>
                        <th style={mainStyle}>
                            <span>Documentation</span>
                            <img className="sort" src={sortIcon} alt="Prodensa supplier" onClick={() => sortTable(order === "ASC" ? "DSC" : "ASC", "compliant")} />
                            <img className="printReport" src={printReport} alt="Prodensa supplier" onClick={() => getTableReport()} />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {supplierDirectoryData?.suppliers?.map((supplier, index) => (
                        <tr key={index}>
                            <td>
                                <div className={`infoContainer ${supplier.certified ? "withBadge" : ""}`}>
                                    {supplier.certified && <img className="cvpBadge" src={cvpBadge} alt="Prodensa Cattenna" />}
                                    <span onClick={() => navigate("./supplierProfile/" + supplier.supplierID)}>{supplier.companyName}</span>
                                </div>
                            </td>
                            <td>
                                <div className="infoContainer">
                                    <span>{supplier.industries.map((category, index) => {
                                        return supplier.industries.length > index + 1 ? category + ", " : category
                                    })}</span>
                                </div>
                            </td>
                            <td>
                                <div className="infoContainer">
                                    <span>{supplier.rating?.$numberDecimal ?? "Unrated"}</span>
                                    {supplier.rating?.$numberDecimal && <img className="starRating" src={starRating} alt="Prodensa Supplier" />}
                                </div>
                            </td>
                            <td>
                                <div className="infoContainer">
                                    <span>{supplier.location}</span>
                                </div>
                            </td>
                            <td>
                                <div className="infoContainer">
                                    <span className={`${supplier.compliant ? "success" : "failed"}`}>
                                        {supplier.compliant ? "Compliant" : "Non-Compliant"}
                                    </span>
                                    <img className="viewProfile" src={viewProfile} alt="Prodensa Supplier" onClick={() => navigate("./supplierProfile/" + supplier.supplierID)} />
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className="d-lg-none supplierRequests">
                {supplierDirectoryData?.suppliers?.map((supplier, indexParent) => (
                    <div key={indexParent} className="supplierRow" onClick={() => navigate("./supplierProfile/" + supplier.supplierID)}>
                        <div className="supplierHeader">
                            {supplier.certified && <img className="cvpBadge" src={cvpBadge} alt="Prodensa Cattenna" />}
                            <h5 className="supplierName">
                                {supplier.companyName}
                            </h5>
                            <span className="rating">
                                {supplier.rating?.$numberDecimal ?? "Unrated"}
                                {supplier.rating?.$numberDecimal && <img className="starRating" src={starRating} alt="Prodensa Supplier" />}
                            </span>
                        </div>
                        <div className="supplierInformation">
                            <span className="supplierValue">{supplier.location}</span>
                            <span className="supplierTitle">Location</span>
                            <span className="supplierValue">{supplier.industries.map((category, index) => {
                                return supplier.industries.length > index + 1 ? category + ", " : category
                            })}</span>
                            <span className="supplierTitle">Industry</span>
                            <span className={`supplierValue ${supplier.compliant ? "success" : "failed"}`}>
                                {supplier.compliant ? "Compliant" : "Non-Compliant"}
                            </span>
                            <span className="supplierTitle">Documentation</span>
                        </div>
                    </div>
                ))}
            </div>

            <PageSelector 
                className="suppliersTablePagination"
                currentPage={currentPage ?? 1}
                totalItems={supplierDirectoryData?.total ?? 0}
                itemsPerPage={itemsPerPage}
                onChange={paginate}
            />
            <span className="tableCount">{tableCount} of {supplierDirectoryData?.total ?? 1}</span>
        </section >
    )
}